import { z } from 'zod';

export const OTHER_FREE_TEXT_CODE = 'OTHER_FREE_TEXT';
export const EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC = 'EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC';

/**
 * Zod schema for the Close Case dialog form.
 *
 * Rules:
 *  - reason                           : always required
 *  - otherReason                      : required (non-whitespace) only when reason === OTHER_FREE_TEXT_CODE
 *  - currentlyEmployedReasonDescription: required (non-whitespace) only when reason === EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC
 */
export const closeCaseSchema = z
  .object({
    reason: z
      .string({ required_error: 'Reason is required' })
      .min(1, 'Reason is required'),

    otherReason: z.string().optional(),
    currentlyEmployedReasonDescription: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.reason === OTHER_FREE_TEXT_CODE &&
      (!data.otherReason || data.otherReason.trim().length === 0)
    ) {
      ctx.addIssue({
        path: ['otherReason'],
        code: z.ZodIssueCode.custom,
        message: 'Please specify the reason for closing this case',
      });
    }

    if (
      data.reason === EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC &&
      (!data.currentlyEmployedReasonDescription ||
        data.currentlyEmployedReasonDescription.trim().length === 0)
    ) {
      ctx.addIssue({
        path: ['currentlyEmployedReasonDescription'],
        code: z.ZodIssueCode.custom,
        message: 'Please specify the reason for closing this case',
      });
    }
  });

export type CloseCaseFormValues = z.infer<typeof closeCaseSchema>;
